<a class="account-card" [routerLink]="route">
  <span class="card-tooltip" role="tooltip">{{ description }}</span>
  <div class="icon-container">
    @if (icon) {
      <umkt-icon [icon]="icon" [size]="'md'" class="card-icon"></umkt-icon>
    }
  </div>
  <div class="content">
    <div class="title-row">
      <h3 class="card-title">{{ title }}</h3>
      @if (showBadge) {
        <span class="card-badge" [attr.aria-label]="badgeAriaLabel">
          {{ badgeLabel }}
        </span>
      }
    </div>
    <p class="card-description">{{ description }}</p>
  </div>
</a>
